import { h, Component } from 'preact';

class SyncBanner extends Component {
    constructor(props) {
        super(props);
        this.autoDismissTimer = null;
    }

    componentDidMount() {
        this.autoDismissTimer = setTimeout(() => {
            const { onDismiss } = this.props;
            if (onDismiss) {
                onDismiss();
            }
        }, 60000);
    }

    componentWillUnmount() {
        if (this.autoDismissTimer) {
            clearTimeout(this.autoDismissTimer);
        }
    }

    render() {
        const { updatedByName, onRefresh, onDismiss, type, detail } = this.props;
        let label;
        if (detail) {
            label = type === 'journal' ? 'This journal was' : 'This sale was';
        } else {
            label = type === 'journal' ? 'Journal list' : 'Sales list';
        }

        return (
            <div class='alert alert-info alert-dismissible fade show d-flex align-items-center mb-2' role='alert'>
                <i class='fa-solid fa-arrows-rotate me-2'></i>
                <span class='me-2'>
                    {label} updated{updatedByName ? ` by ${updatedByName}` : ''}.
                    {detail && ' Please re-open the sale to see the latest changes.'}
                </span>
                {!detail && <button type='button' class='btn btn-sm btn-info me-2' onClick={onRefresh}>
                    Click to refresh
                </button>}
                <button type='button' class='btn-close' onClick={onDismiss} aria-label='Close'></button>
            </div>
        );
    }
}

export default SyncBanner;
